(function () {
  const openButtons = document.querySelectorAll('.button-open');
  const addFocusTrap = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };
  const getParents = (el) => {
    for (var parents = []; el; el = el.parentNode) {
      parents.push(el);
    }
    return parents;
  };
  const closeModalOnOutsideClick = (event) => {
    const modalContent = event.currentTarget.querySelector(
      '.staff-cards__modal-content'
    );
    if (
      event.target !== modalContent &&
      !getParents(event.target).includes(modalContent)
    ) {
      event.currentTarget.close();
      event.currentTarget.removeEventListener('keydown', addFocusTrap);
    }
  };
  if (!openButtons) return;
  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.parentElement.nextElementSibling;
      modal.toggleAttribute('open');
      modal.querySelector('.button-close-modal').focus();
      modal.addEventListener('keydown', addFocusTrap);
      modal.addEventListener('click', closeModalOnOutsideClick);
    });
  });
  const closeButtons = document.querySelectorAll('.button-close-modal');
  if (!closeButtons) return;
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('dialog');
      modal.close();
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openModal = document.querySelector('dialog[open]');
      if (openModal) {
        openModal.close();
        openModal.removeEventListener('keydown', addFocusTrap);
        openModal.removeEventListener('click', closeModalOnOutsideClick);
      }
    }
  });
})();
